import { api } from '@/api'

/**
 * Gets a payslip
 *
 * @param {number} payslipId
 * @param {?string} language
 * @returns {Payslip}
 */
export const getPayslip = async (payslipId, language) => {
  const res = await api.get(`payslips/${payslipId}`, {
    params: {
      language
    }
  })
  return res.data
}

/**
 * Gets payslip items
 *
 * @param {number} payslipId
 * @param {?string} language
 * @returns {PayslipItem[]}
 */
export const getPayslipItems = async (payslipId, language) => {
  const res = await api.get(`payslips/${payslipId}/items`, {
    params: {
      language
    }
  })
  return res.data
}
